import Crud from './crud';
import { request_list, update_detail } from '@/commons/hpod';
import Vue from 'vue';
var crud = new Crud('products', 'sản phẩm');

const state = {
    ...crud.state,
    exp: {},
    selected: {
        id: 0
    }
};
const getters = {
    ...crud.getters,
};
const actions = {
    ...crud.actions,
    getExpList({ commit }, param) {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                commit("setLoading", { loading: true });
                request_list('products/exp', item => {
                    commit('setExpList', item);
                    commit("setLoading", { loading: false });
                    resolve(item.data ? item.data : item);
                }, Vue.http, param, this.state.authentication.token);
            }, 100)
        })
    },
    copyDetail({ commit }, id) {
        commit("setLoading", { loading: true });
        update_detail('products/copy', data => {
            commit('setExpList', data);
            commit("setLoading", { loading: false });
        }, Vue.http, param, this.state.authentication.token);
    }
};
const mutations = {
    ...crud.mutations,
    setExpList(state, data) {
        state.exp = data;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};